var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectAndEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.017 5.388a1.188 1.188 0 0 1 1.371-1.37l11.957 2.046c1.073.184 1.354 1.596.431 2.176l-4.308 2.709 6.01 6.01a1.781 1.781 0 0 1-2.519 2.52l-6.01-6.011-2.71 4.308c-.58.923-1.991.643-2.175-.431L4.017 5.388Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectAndEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/select_and_edit.dee3fb8ae571fb636ae1aacbbbef536a.svg";